import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Ticket, X } from 'lucide-react';

const EVENT_DATE = new Date('2026-08-21T17:00:00Z'); // Aug 21, 2026 noon CT

const CountdownBanner = () => {
  const location = useLocation();
  const [now, setNow] = useState(new Date());
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60000); // update every minute
    return () => clearInterval(id);
  }, []);

  // Don't show on event/ticket pages (already there), admin pages, or if dismissed
  const hidden = ['/elevated-escape', '/file-room'].some(p => location.pathname.startsWith(p));
  if (hidden || dismissed) return null;

  const diff = EVENT_DATE - now;
  if (diff <= 0) return null; // Event has passed

  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);

  let timeText;
  if (days > 1) timeText = `${days} days`;
  else if (days === 1) timeText = '1 day';
  else timeText = `${hours} hours`;

  return (
    <div className="bg-brand-dark border-b border-brand-gold/30 relative z-30" data-testid="countdown-banner">
      <div className="mx-auto max-w-7xl px-4 py-2 flex items-center justify-center gap-3 text-sm">
        <span className="text-brand-gold font-medium hidden sm:inline">The Elevated Escape</span>
        <span className="text-gray-400 hidden sm:inline">|</span>
        <span className="text-white">
          <span className="font-bold text-brand-gold">{timeText}</span> until the retreat
        </span>
        <Link
          to="/elevated-escape/tickets"
          className="inline-flex items-center gap-1.5 bg-brand-gold text-brand-dark px-3 py-1 text-xs font-bold hover:opacity-90 transition-opacity ml-2"
          data-testid="banner-get-tickets"
        >
          <Ticket className="w-3 h-3" /> Get Tickets
        </Link>
        <button
          onClick={() => setDismissed(true)}
          className="absolute right-3 text-gray-500 hover:text-white transition-colors"
          data-testid="banner-dismiss"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default CountdownBanner;
